import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ProjectWorkflowProvider } from '../../contexts/ProjectWorkflowContext';
import PublisherLayout from './PublisherLayout';
import WorkflowLayout from './WorkflowLayout';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isPublisher } = useAuth();

  if (isPublisher) {
    return <PublisherLayout>{children}</PublisherLayout>;
  }

  return (
    <ProjectWorkflowProvider>
      <WorkflowLayout>{children}</WorkflowLayout>
    </ProjectWorkflowProvider>
  );
};

export default Layout;
